<div class="content">
    <div class="row" *ngIf="stateDialog === ''">
        <div class="box-info"
            [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
            {{ "updated_consent" | translate }}
            <br>
            <p class="more" (click)="learnMore('ioh')" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
                aria-controls="offcanvasBottom"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
                {{ "more" | translate }}
            </p>
        </div>
        <p class="consent-title"
            [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
            {{ "personalized" | translate }}
        </p>
        <p class="consent-content"
            [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
            {{ "personalized_consent" | translate }}
        </p>
        <br>
        <p class="more" (click)="learnMore('other')" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
            aria-controls="offcanvasBottom"
            [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
            {{ "more" | translate }}
        </p>
    </div>
    <div class="text-center">
        <app-dialog *ngIf="stateDialog !== '' " [dialogType]="stateDialog" [showButton]="showButton"
            (btnAction)="btnAction()"></app-dialog>
    </div>
</div>

<div class="card btn-wrapper" *ngIf="stateDialog === ''">
    <div class="row" *ngIf="!consentType">
        <div class="col-12">
            <button class="btn-agree"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'bg-orange' : platform === 'tri' }"
                type="button" (click)="save(1)">
                {{ "agree" | translate}}
            </button>
        </div>
        <div class="col-12">
            <button class="btn-disagree" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottomDisagree"
                aria-controls="offcanvasBottomDisagree"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }"
                type="button">
                {{ "disagree" | translate}}
            </button>
        </div>
    </div>
    <div class="row" *ngIf="consentType">
        <div class="col-9 pe-0 consent-manage"
            [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
            {{ "already_consent" | translate}}
        </div>
        <div class="col-3 align-content-center">
            <p class="more text-center" (click)="manageConsent()"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
                {{ "manage" | translate }}
            </p>
        </div>
    </div>
</div>

<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
    <button type="button" class="btn-close text-reset close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    <div class="offcanvas-header consent-title"
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        {{ "consentTnc" | translate }}
    </div>
    <div class="offcanvas-body">
        <div #top></div>
        <app-privacy-policy *ngIf="drawerTncIoh" [lang]="currentlang"></app-privacy-policy>
        <app-privacy-policy-personalized [lang]="currentlang" *ngIf="!drawerTncIoh"></app-privacy-policy-personalized>
    </div>
</div>

<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottomDisagree"
    aria-labelledby="offcanvasBottomLabel">
    <button type="button" class="btn-close text-reset close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    <div class="offcanvas-body">
        <app-dialog-confirmation (btnAction)="save($event)"></app-dialog-confirmation>
    </div>
</div>